export default "__VITE_ASSET__02cIsRpskrhgAZO9K3KKmw__"